import {
  IBulkUploadStatus,
  IBulkUploadTemplates,
  bulkUploadStatusSchema,
  bulkUploadTemplatesSchema,
} from '../../schemas/SourcingBulkUpload.schema';
import { MaggieHttp } from '../MaggieHttp';

export async function getBulkUploadTemplates(
  listId: string,
  entityType: 'company' | 'person'
): Promise<IBulkUploadTemplates> {
  const { data } = await MaggieHttp.sourcing.get<IBulkUploadTemplates>('/api/v1/bulk-upload/templates', {
    params: { listId, entityType },
  });
  return bulkUploadTemplatesSchema.cast(data);
}

export async function getBulkUploadStatus(id: string): Promise<IBulkUploadStatus> {
  const { data } = await MaggieHttp.sourcing.get<IBulkUploadStatus>(`/api/v1/bulk-upload/${id}/status`);
  return bulkUploadStatusSchema.cast(data);
}
